

const UtilFormats = {
  getUserNumberFormat: (value, toDivide) => {
    let numberFormat;

    const returnValue = (value, divide) => {
      if (isNaN(value)) {
        return value;
      }

      try {
        if (divide && toDivide) {
          value = value / 100;
        }
        return numberFormat.format(value);
      } catch (error) {
        return value;
      }
    };

    let formatNumber = 11;

    switch (formatNumber) {
      case 1:
        numberFormat = new Intl.NumberFormat('en-US', {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
          minimumIntegerDigits: 1,
        });
        return returnValue(value, true);
      case 7:
        numberFormat = new Intl.NumberFormat('ja-JP', {
          maximumFractionDigits: 2,
        });
        return returnValue(value, false);
      case 9:
        numberFormat = new Intl.NumberFormat('ru-RU', {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        });
        return returnValue(value, true);
      case 11:
        numberFormat = new Intl.NumberFormat('ru-RU', {
          maximumFractionDigits: 2,
        });
        return returnValue(value, false);
      default:
        return value;
    }
  },
  getUserCurrencyFormat: (
    value,
    customCurrencySymbol,
    customCurrencyPlacement
  ) => {
    let currency =
      customCurrencySymbol !== undefined
        ? customCurrencySymbol
        : '$';
    let operand = '';
    let currencyPlacement =
      customCurrencyPlacement !== undefined
        ? customCurrencyPlacement
        : 1;
    if (!value) {
      value = 0;
    }
    if (!currency) {
      currency = '';
    }
    if (typeof value === 'number') {
      value = value + '';
    }
    if (value[0] === '-') {
      value = value.replace('-', ' ');
      operand = '-';
    }
    value = value.replace(currency, ' ');
    switch (currencyPlacement) {
      case 1:
        return operand + currency + (value?.trim() || '');
      case 2:
        return operand + (value?.trim() || '') + currency;
      default:
        return operand + (value?.trim() || '');
    }
  },
  getUserCurrencyFormatWithValueForView: (
    value,
    customCurrencySymbol,
    customCurrencyPlacement
  ) => {
    value = UtilFormats.getUserNumberFormat(value);
    return UtilFormats.getUserCurrencyFormat(
      value,
      customCurrencySymbol,
      customCurrencyPlacement
    );
  },
  getFormatCurrencyPlacemenetLabel: (value, symbol, placement) => {
    const formattedAmount = value.toLocaleString('en-US');
    switch (placement) {
      case 1:
        return `${symbol}${formattedAmount}`;
      case 2:
        return `${formattedAmount}${symbol}`;
      case 3:
        return formattedAmount;
      default:
        return formattedAmount;
    }
  },
};

export default UtilFormats;
